import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  line: {
    borderBottom: `1px solid ${theme.props.border}`,
    "& > button": {
      marginBottom: -1,
    }
  },
  lighter: {
    fontSize: "16px !important",
    letterSpacing: "normal !important",
    fontWeight: "normal !important",
  }
}));

export default useStyle;
